import type { Id } from "@convex/_generated/dataModel";
import { createFileRoute } from "@tanstack/react-router";
import { BudgetTab } from "@/features/employee/budget-tab";

export const Route = createFileRoute("/_app/_main/team/$employeeId/budget")({
  component: () => <BudgetTab employeeId={Route.useParams().employeeId as Id<"employees">} />,
});
